export default {
  feedComments: [],
  count: [],
};
